<template>
  <Admin>
    <v-main class="wrapper">
      <v-container fluid>
           <div class="tw-grid tw-grid-cols-4 tw-grid-rows-2 tw-gap-4">
                <div class="tw-col-span-1 tw-row-span-2 tw-border tw-shadow-lg tw-border-gray-500 tw-rounded-xl tw-p-4 tw-flex tw-items-center">
                     <div class="tw-flex tw-gap-4 tw-items-center">
                          <v-icon class="tw-text-4xl tw-bg-blue-500 tw-p-2 tw-rounded-full" color="white">mdi-file-document</v-icon>
                          <div class="tw-flex tw-flex-col">
                            <h1 class="tw-text-2xl font-bold tw-text-blue-500"><b>{{ totalUpload || 0 }} <span class="tw-text-sm">(100%)</span></b></h1>
                            <h4>เอกสารทั้งหมด</h4>
                          </div>
                     </div>
                </div>
                 <div class="tw-flex tw-gap-4 tw-items-center tw-col-span-1 tw-row-span-1  tw-border tw-shadow-lg tw-border-gray-500 tw-rounded-xl tw-p-4">
                          <v-icon class="tw-text-4xl tw-bg-green-500 tw-p-2 tw-rounded-full" color="white">mdi-gold</v-icon>
                          <div class="tw-flex tw-flex-col">
                            <h1 class="tw-text-2xl font-bold tw-text-green-500"><b>{{ totalComplete || 0 }} <span class="tw-text-sm">({{ totalCompletePct || 0 }}%)</span></b></h1>
                            <h4>เอกสารสมบูรณ์</h4>
                          </div>
               </div>
               <div class="tw-flex tw-gap-4 tw-items-center tw-col-span-1 tw-row-span-1  tw-border tw-shadow-lg tw-border-gray-500 tw-rounded-xl tw-p-4">
                          <v-icon class="tw-text-4xl tw-h-14 tw-w-14 tw-bg-warning tw-p-2 tw-rounded-full" color="white">mdi-flag</v-icon>
                          <div class="tw-flex tw-flex-col">
                            <h1 class="tw-text-2xl font-bold tw-text-warning"><b>{{ totalIncomplete }} <span class="tw-text-sm">({{ totalIncompletePct || 0 }}%)</span></b></h1>
                            <h4>เอกสารไม่สมบูรณ์ (Warning, Error)</h4>
                          </div>
               </div>
               <div class="tw-flex tw-gap-4 tw-items-center tw-col-span-1 tw-row-span-1  tw-border tw-shadow-lg tw-border-gray-500 tw-rounded-xl tw-p-4">
                          <v-icon class="tw-text-4xl tw-bg-red-500 tw-p-2 tw-rounded-full" color="white">mdi-file-document-alert</v-icon>
                          <div class="tw-flex tw-flex-col">
                            <h1 class="tw-text-2xl font-bold tw-text-red-500"><b>{{ totalReject || 0 }} <span class="tw-text-sm">({{ totalRejectPct || 0 }}%)</span></b></h1>
                            <h4>เอกสารผิดพลาด</h4>
                          </div>
               </div>
                <div class="tw-col-span-1  w-row-span-1 tw-flex tw-items-center tw-gap-4 tw-border tw-shadow-lg tw-border-gray-500 tw-rounded-xl tw-p-4">
                  <v-icon class="tw-text-4xl tw-h-14 tw-w-14 tw-bg-pdf-gray tw-p-2 tw-rounded-full" color="white">mdi-file-edit</v-icon>
                          <div class="tw-flex tw-flex-col">
                            <h1 class="tw-text-2xl font-bold tw-text-pdf-gray"><b>{{ totalEdited || 0 }} </b></h1>
                            <h4>จำนวนการแก้ไข</h4>
                          </div>
                </div>
                <!-- <div class="tw-col-span-1 tw-row-span-1 tw-flex tw-items-center tw-gap-4 tw-border tw-shadow-lg tw-border-gray-500 tw-rounded-xl tw-p-4">
                  <v-icon class="tw-text-4xl tw-h-14 tw-w-14 tw-bg-pdf-gray tw-p-2 tw-rounded-full" color="white">mdi-file-replace</v-icon>
                          <div class="tw-flex tw-flex-col">
                            <h1 class="tw-text-2xl font-bold tw-text-pdf-gray"><b>{{ totalReplace || 0 }} </b></h1>
                            <h4>จำนวนการเปลี่ยนทับ</h4>
                          </div>
                </div> -->
           </div>
           <h3 class="tw-text-lg tw-font-bold tw-my-8">เอกสารรอตรวจสอบ - ({{ totalIncomplete + totalComplete || 0 }})</h3>
           <v-data-table
              dense
              :headers="headersCompleted"
              :items="completedAndIncompletedFiles"
              item-key="id"
              class="elevation-1"
            ></v-data-table>
            <h3 class="tw-text-lg tw-font-bold tw-my-8">
                เอกสารที่มีการแก้ไข - ({{ totalEdited || 0 }})
              </h3>
       
              <v-data-table
    dense
    :headers="headersEdited"
    :items="editedFiles"
    item-key="id"
    show-expand
    class="elevation-1"
  >
    <!-- your normal rows -->
    
    <!-- expanded slot -->
    <template v-slot:expanded-item="{ item }">
      <!-- Vuetify will wrap this <td> in its own <tr> -->
      <td :colspan="headersEdited.length + 1" class="expanded-item-td">
        <div
          v-for="activity in item.userActivities.filter(a => a.eventType === 'UPDATE')"
          :key="activity.id"
          class="expanded-activity"
        >
          <h4 class="font-semibold mb-2">
            แก้ไขเมื่อ {{ formatTimestamp(activity.timeCreate) }}
          </h4>

          <v-simple-table dense class="no-wrap-table mb-4">
            <thead>
              <tr>
                <th class="text-no-wrap">Field</th>
                <th class="text-no-wrap">Old</th>
                <th class="text-no-wrap">New</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="edit in getEditsArray(activity.eventDetails)"
                :key="edit.fieldName"
              >
                <td class="text-no-wrap">{{ edit.fieldName }}</td>
                <td class="text-no-wrap"><code>{{ edit.oldVal }}</code></td>
                <td class="text-no-wrap"><code>{{ edit.newVal }}</code></td>
              </tr>
            </tbody>
          </v-simple-table>

          <div v-if="getDocLineEdits(activity.eventDetails).length">
            <h5 class="font-medium mb-2">LineItem Changes</h5>
            <v-simple-table dense class="no-wrap-table">
              <thead>
                <tr>
                  <th class="text-no-wrap">Line</th>
                  <th class="text-no-wrap">Field</th>
                  <th class="text-no-wrap">Old</th>
                  <th class="text-no-wrap">New</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="edit in getDocLineEdits(activity.eventDetails)"
                  :key="`doc-${activity.id}-${edit.lineIndex}-${edit.fieldName}`"
                >
                  <td class="text-no-wrap">{{ edit.lineIndex + 1 }}</td>
                  <td class="text-no-wrap">{{ edit.fieldName }}</td>
                  <td class="text-no-wrap"><code>{{ edit.oldVal }}</code></td>
                  <td class="text-no-wrap"><code>{{ edit.newVal }}</code></td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>

          <div v-if="getPaymentEdits(activity.eventDetails).length">
            <h5 class="font-medium mb-2">Payment Changes</h5>
            <v-simple-table dense class="no-wrap-table">
              <thead>
                <tr>
                  <th class="text-no-wrap">Field</th>
                  <th class="text-no-wrap">Old</th>
                  <th class="text-no-wrap">New</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="edit in getPaymentEdits(activity.eventDetails)"
                  :key="`pay-${activity.id}-${edit.fieldName}`"
                >
                  <td class="text-no-wrap">{{ edit.fieldName }}</td>
                  <td class="text-no-wrap"><code>{{ edit.oldVal }}</code></td>
                  <td class="text-no-wrap"><code>{{ edit.newVal }}</code></td>
                </tr>
              </tbody>
            </v-simple-table>
          </div>
        </div>
      </td>
    </template>
  </v-data-table>


            <h3 class="tw-text-lg tw-font-bold tw-my-8">เอกสารผิดพลาด - ({{ totalReject || 0 }})</h3>
           <v-data-table
              dense
              :headers="headersRejected"
              :items="rejectedFiles"
               item-key="id"
              class="elevation-1"
            ></v-data-table>




            <!-- Replace / Failure Logs Table -->
            <!-- <h3 class="tw-text-lg tw-font-bold tw-my-8">บันทึกการเปลี่ยนทับ / ข้อผิดพลาด - ({{ replaceLogs.length }})</h3>
            <v-data-table
              dense
              :headers="headersReplace"
              :items="replaceLogs"
              item-key="id"
              class="elevation-1"
              style="table-layout: fixed; white-space: nowrap;"
            ></v-data-table> -->
           <!-- Google Drive Stats -->
           <div v-if="shouldShowDriveStats" class="tw-mt-8 tw-border tw-shadow-lg tw-border-gray-200 tw-rounded-xl tw-p-4">
             <div class="tw-flex tw-items-center tw-justify-between tw-mb-4">
               <div class="tw-flex tw-items-center tw-gap-2">
                 <v-icon color="blue darken-2">mdi-google-drive</v-icon>
                 <span class="tw-font-bold tw-text-base tw-text-gray-700">Google Drive — สถิติการรับไฟล์</span>
               </div>
               <v-btn x-small text color="grey" :loading="isLoadingDriveStats" @click="loadDriveStats">
                 <v-icon left x-small>mdi-refresh</v-icon>
                 รีเฟรช
               </v-btn>
             </div>

             <div v-if="isLoadingDriveStats" class="tw-flex tw-justify-center tw-py-6">
               <v-progress-circular indeterminate color="primary" size="28" />
             </div>

             <div v-else-if="!driveStats" class="tw-text-center tw-text-gray-400 tw-text-sm tw-py-4">
               ยังไม่มีข้อมูล Google Drive (จะปรากฏหลังจากมีไฟล์เข้ามาครั้งแรก)
             </div>

             <div v-else>
               <div class="tw-grid tw-grid-cols-2 tw-gap-3 sm:tw-grid-cols-5">
                 <div class="tw-border tw-shadow tw-border-blue-100 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
                   <v-icon class="tw-bg-blue-500 tw-p-2 tw-rounded-full" color="white">mdi-webhook</v-icon>
                   <div>
                     <h1 class="tw-text-2xl tw-font-bold tw-text-blue-500">{{ driveStats.totalWebhookEvents || 0 }}</h1>
                     <h4 class="tw-text-xs tw-text-gray-500">Webhook (มีไฟล์)</h4>
                   </div>
                 </div>
                 <div class="tw-border tw-shadow tw-border-gray-100 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
                   <v-icon class="tw-bg-gray-400 tw-p-2 tw-rounded-full" color="white">mdi-bell-outline</v-icon>
                   <div>
                     <h1 class="tw-text-2xl tw-font-bold tw-text-gray-500">{{ driveStats.totalWebhookPings || 0 }}</h1>
                     <h4 class="tw-text-xs tw-text-gray-500">Ping ทั้งหมด</h4>
                   </div>
                 </div>
                 <div class="tw-border tw-shadow tw-border-indigo-100 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
                   <v-icon class="tw-bg-indigo-500 tw-p-2 tw-rounded-full" color="white">mdi-file-search</v-icon>
                   <div>
                     <h1 class="tw-text-2xl tw-font-bold tw-text-indigo-500">{{ driveStats.totalFilesDetected || 0 }}</h1>
                     <h4 class="tw-text-xs tw-text-gray-500">ไฟล์ที่ตรวจพบ</h4>
                   </div>
                 </div>
                 <div class="tw-border tw-shadow tw-border-green-100 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
                   <v-icon class="tw-bg-green-500 tw-p-2 tw-rounded-full" color="white">mdi-check-circle</v-icon>
                   <div>
                     <h1 class="tw-text-2xl tw-font-bold tw-text-green-500">{{ driveStats.totalFilesProcessed || 0 }}</h1>
                     <h4 class="tw-text-xs tw-text-gray-500">ประมวลผลสำเร็จ</h4>
                   </div>
                 </div>
                 <div class="tw-border tw-shadow tw-border-red-100 tw-rounded-xl tw-p-4 tw-flex tw-items-center tw-gap-3">
                   <v-icon class="tw-bg-red-500 tw-p-2 tw-rounded-full" color="white">mdi-alert-circle</v-icon>
                   <div>
                     <h1 class="tw-text-2xl tw-font-bold tw-text-red-500">{{ driveStats.totalFilesError || 0 }}</h1>
                     <h4 class="tw-text-xs tw-text-gray-500">ข้อผิดพลาด</h4>
                   </div>
                 </div>
               </div>

               <div class="tw-mt-4 tw-flex tw-flex-wrap tw-gap-4 tw-text-xs tw-text-gray-500 tw-border-t tw-border-gray-100 tw-pt-3">
                 <span v-if="driveStats.totalProcessingRuns">
                   <v-icon x-small>mdi-timer-outline</v-icon>
                   เวลาเฉลี่ย: <strong class="tw-text-gray-700">{{ avgProcessingTime }}</strong>
                 </span>
                 <span v-if="driveStats.lastWebhookAt">
                   <v-icon x-small>mdi-clock-outline</v-icon>
                   Webhook ล่าสุด: <strong class="tw-text-gray-700">{{ formatDriveDate(driveStats.lastWebhookAt) }}</strong>
                 </span>
                 <span v-if="driveStats.lastProcessedAt">
                   <v-icon x-small>mdi-calendar-check</v-icon>
                   ประมวลผลล่าสุด: <strong class="tw-text-gray-700">{{ formatDriveDate(driveStats.lastProcessedAt) }}</strong>
                 </span>
                 <span v-if="driveStats.lastProcessingDurationMs">
                   <v-icon x-small>mdi-flash</v-icon>
                   ครั้งล่าสุดใช้: <strong class="tw-text-gray-700">{{ (driveStats.lastProcessingDurationMs / 1000).toFixed(1) }}s</strong>
                 </span>
               </div>
             </div>
           </div>
      </v-container>
    </v-main>
  </Admin>
</template>

<script>
import Admin from "@/components/admin/admin-main-template";
import fc from "@/firebaseConfig";
import moment from "moment";
import { mapState } from "vuex";

export default {
  name: "ApAutomationCompleteNoEditMultiStatus",
  components: { Admin },
  data() {
    return {
      purchaseInvoices: [],
      replaceLogs: [],
      searchStartDate: null,
      searchEndDate: null,
      isLoading: false,
      unsubscribe: null,
      unsubscribeLogs: null,
      driveStats: null,
      isLoadingDriveStats: false,
      headersCompleted: [
        {
          text: 'ชื้่อไฟล์',
          value: 'fileName',
        },
        { text: 'สถานะ', value: 'status' },
        { text: 'เลขที่เอกสาร', value: 'docId' },
        { text: 'รหัสผู้จำหน่าย', value: 'cardCode' },
        { text: 'ชื่อผู้จำหน่าย', value: 'cardName' },
        { text: 'รหัสสาขา', value: 'branchCode' },
        { text: 'เลขที่ผู้เสียภาษี', value: 'taxId' },
      ],
      headersEdited: [
        {
          text: 'ชื้่อไฟล์',
          value: 'fileName',
        },
        { text: 'เลขที่เอกสาร', value: 'docId' },
        { text: 'รหัสผู้จำหน่าย', value: 'cardCode' },
        { text: 'ชื่อผผู้่จำหน่าย', value: 'cardName' },
        { text: 'รหัสสาขา', value: 'branchCode' },
        { text: 'เลขที่ผู้เสียภาษี', value: 'taxId' },
      ],
      headersReplace: [
      {  text: 'ประเภท', value: 'eventType' },
        {  text: 'ชื่อไฟล์', value: 'fileName' },
        { text: 'เลขที่เอกสาร', value: 'invoiceId' },
        { text: 'รหัสผู้จำหน่าย', value: 'vendorCode' },
        { text: 'ชื่อผผู้่จำหน่าย', value: 'vendorName' },
        { text: 'รหัสสาขา', value: 'vendorBranch' },
        { text: 'เลขที่ผู้เสียภาษี', value: 'vendorTaxId' },
        { text: 'อ้างอิงเอกสารไฟล์', value: 'fileDocRef' },
        { text: 'ID เอกสารที่มีอยู่', value: 'existingDocId' },
        { text: 'สถานะเดิม', value: 'oldStatus' },
        { text: 'จำนวนการเปลี่ยนทับ', value: 'replaceCount' },
      ],
      headersRejected: [
        {
          text: 'ชื้่อไฟล์',
          value: 'fileName',
        },
        { text: 'สาเหตุ', value: 'failureMessage' },
      ],
    };
  },
  computed: {
    ...mapState({
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
    }),
    isApTypeOne() {
      return this.selectedCompanyProductList?.isApAutomateType === 1;
    },
    isApTypeTwo() {
      return this.selectedCompanyProductList?.isApAutomateType === 2;
    },
    shouldShowDriveStats() {
      return this.isApTypeOne || this.isApTypeTwo;
    },
    avgProcessingTime() {
      if (!this.driveStats) return "-";
      const runs = this.driveStats.totalProcessingRuns || 0;
      const total = this.driveStats.totalProcessingTimeMs || 0;
      if (!runs) return "-";
      const avg = total / runs;
      return avg >= 1000 ? (avg / 1000).toFixed(1) + "s" : Math.round(avg) + "ms";
    },
    totalUpload() {
      return this.purchaseInvoices.length;
    },
    totalReject() {
      return this.purchaseInvoices.filter(inv => inv.status === "REJECTED").length;
    },
    totalEdited() {
      return this.purchaseInvoices.filter(inv =>
        inv.isEdited
      ).length;
    },
    totalReplace() {
      return this.replaceLogs.filter(log => log.eventType?.toUpperCase() === "REPLACE").length;
    },
    totalReplacePct() { return this.calcPercentage(this.totalReplace); },
    totalComplete() {
      return this.purchaseInvoices.filter(inv =>
        (inv.status === "PENDING_APPROVAL" || inv.status === "POSTING" || inv.status === "SUCCESS")
      ).length;
    },
    totalIncomplete() {
      return this.purchaseInvoices.filter(inv =>
        inv.status === "WARNING" || inv.status === "ERROR" 
      ).length;
    },
    totalRejectPct() { return this.calcPercentage(this.totalReject); },
    totalCompletePct() { return this.calcPercentage(this.totalComplete); },
    totalEditedPct() { return this.calcPercentage(this.totalEdited); },
    totalIncompletePct() { return this.calcPercentage(this.totalIncomplete); },
    completedAndIncompletedFiles() {
      return this.purchaseInvoices.filter(inv =>
        (inv.status === "PENDING_APPROVAL" || inv.status === "POSTING" || inv.status === "SUCCESS" || inv.status === "WARNING" || inv.status === "ERROR")
      );
    },
    rejectedFiles() {
      return this.purchaseInvoices.filter(inv => inv.status === "REJECTED");
    },
    editedFiles() {
      return this.purchaseInvoices.filter(inv => inv.isEdited);
    },
  },
  watch: {
    shouldShowDriveStats(newValue) {
      if (newValue && !this.driveStats && !this.isLoadingDriveStats) {
        this.loadDriveStats();
      }

      if (!newValue) {
        this.driveStats = null;
      }
    },
  },
  methods: {
    getCompanyProductList() {
      const companyId = this.$route.params.companyId;
      return this.$store.dispatch("companies/getCompanyProductList", { companyId });
    },
    getPaymentEdits(eventDetails) {
    const edits = [];
    const pay = eventDetails?.payment;
    if (!pay || typeof pay !== "object") return edits;

    Object.entries(pay).forEach(([field, detail]) => {
      // skip if it isn’t an object with old/new
      if (!detail || typeof detail.old === "undefined" && typeof detail.new === "undefined") return;

      edits.push({
        fieldName: field,
        oldVal:
          detail.old && typeof detail.old === "object"
            ? JSON.stringify(detail.old)
            : detail.old ?? "",
        newVal:
          detail.new && typeof detail.new === "object"
            ? JSON.stringify(detail.new)
            : detail.new ?? "",
      });
    });

    return edits;
  },
    getDocLineEdits(eventDetails) {
    const edits = [];
    const arr = eventDetails?.docLine;
    if (!Array.isArray(arr)) return edits;

    arr.forEach((lineChanges, idx) => {
      Object.entries(lineChanges).forEach(([field, detail]) => {
        edits.push({
          lineIndex: idx,
          fieldName: field,
          oldVal:
            detail.old && typeof detail.old === "object"
              ? JSON.stringify(detail.old)
              : detail.old ?? "",
          newVal:
            detail.new && typeof detail.new === "object"
              ? JSON.stringify(detail.new)
              : detail.new ?? "",
        });
      });
    });

    return edits;
  },
    getEditsArray(eventDetails) {
    if (!eventDetails) return [];

    return Object.entries(eventDetails).map(([field, detail]) => ({
      fieldName: field,
      oldVal:
        detail.old && typeof detail.old === "object"
          ? JSON.stringify(detail.old)
          : detail.old ?? "",
      newVal:
        detail.new && typeof detail.new === "object"
          ? JSON.stringify(detail.new)
          : detail.new ?? "",
    }));
    },

    formatDriveDate(val) {
      if (!val) return "";
      const d = val instanceof Date ? val : (val.toDate ? val.toDate() : new Date(val));
      return moment(d).format("DD/MM/YYYY HH:mm:ss");
    },
    async loadDriveStats() {
      this.isLoadingDriveStats = true;
      try {
        const companyId = this.$route.params.companyId;
        const snap = await fc.db
          .collection("Companies").doc(companyId)
          .collection("GoogleDriveStats").doc("summary")
          .get();
        this.driveStats = snap.exists ? snap.data() : null;
      } catch (err) {
        console.error("loadDriveStats error:", err);
        this.driveStats = null;
      } finally {
        this.isLoadingDriveStats = false;
      }
    },
    formatTimestamp(ts) {
      if (!ts?.seconds) return "";
      const d = new Date(ts.seconds * 1000);
      return moment(d).format("DD/MM/YYYY HH:mm:ss");
    },
    calcPercentage(count) {
      return this.totalUpload === 0 ? 0 : Math.round((count / this.totalUpload) * 100);
    },
    async setupRealtimeListener() {
      this.isLoading = true;
      const companyID = this.$route.params.companyId;
      this.unsubscribe = fc.db
        .collection(`Companies/${companyID}/PurchaseInvoices`)
        .orderBy("timeCreate", "desc")
        .onSnapshot(async snapshot => {
          const docs = snapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
            userActivities: []
          }));

          if (!docs.length) {
            this.purchaseInvoices = [];
            this.isLoading = false;
            return;
          }

          // Batch the invoice IDs into chunks of 10
          const invoiceIds = docs.map(d => d.id);
          const chunks = [];
          for (let i = 0; i < invoiceIds.length; i += 10) {
            const slice = invoiceIds.slice(i, i + 10);
            chunks.push(
              fc.db
                .collection(`Companies/${companyID}/UserActivities`)
                .where("targetDocID", "in", slice)
                .get()
            );
          }

          // Wait for all activity queries
          const actSnapshots = await Promise.all(chunks);
          const allActivities = actSnapshots.flatMap(actSnap =>
            actSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
          );

          // Group by targetDocID
          const activitiesByDoc = allActivities.reduce((acc, act) => {
            (acc[act.targetDocID] = acc[act.targetDocID] || []).push(act);
            return acc;
          }, {});

          // Merge into invoices
          this.purchaseInvoices = docs.map(inv => ({
            ...inv,
            userActivities: activitiesByDoc[inv.id] || []
          }));

          this.isLoading = false;
        });

      
      // Fetch logs
     // Realtime FailureLogs listener
     this.unsubscribeLogs = fc.db
        .collection(`Companies/${companyID}/PurchaseInvoiceFailureLogs`)
        .orderBy("timestamp", "desc")
        .onSnapshot(snapshot => {
          this.replaceLogs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        });
    }
  },
  async mounted() {
    this.setupRealtimeListener();
    await this.getCompanyProductList();
    if (this.shouldShowDriveStats) {
      this.loadDriveStats();
    }
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
    if (this.unsubscribeLogs) this.unsubscribeLogs();
  }
};
</script>

<style scoped>
.ap-automation-summary {
  padding: 16px;
}

.filter-row {
  margin-bottom: 12px;
}

/* Summaries styling */
.summary-boxes {
  margin-top: 20px;
}
.summary-card {
  text-align: center;
  padding: 8px 0;
}



.summary-value {
  font-size: 1.5em;
  margin-top: 6px;
}
.summary-percentage {
  font-size: 1.1em;
  margin-top: 4px;
  color: #666;
}
.mt-4 {
  margin-top: 20px;
}
.no-data {
  margin: 20px 0;
}

/* Just some spacing for each expanded user activity */
.expanded-activity {
  border: 1px solid #ebeef5;
  padding: 8px;
  margin-bottom: 10px;
  background: #fafafa;
  border-radius: 4px;
}

.no-wrap-table th,
.no-wrap-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.expanded-item-td {
  padding: 0 !important;
}

</style>
